var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0475,
    cy: 21.5905,
    r: 20.8373,
    stroke: "url(#paint0_linear_4_88842)",
    strokeWidth: 1.50631
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_88842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4774 18.0781V28.1202H14.4648V18.0781H17.4774Z",
    fill: "url(#paint1_linear_4_88842)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4774 14.563C17.4774 15.3949 16.803 16.0693 15.9711 16.0693C15.1392 16.0693 14.4648 15.3949 14.4648 14.563C14.4648 13.731 15.1392 13.0566 15.9711 13.0566C16.803 13.0566 17.4774 13.731 17.4774 14.563Z",
    fill: "url(#paint2_linear_4_88842)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.644 18.0781C27.8262 18.0781 28.7671 18.458 29.4667 19.2177C30.1784 19.9655 30.5342 20.9982 30.5342 22.3157V28.1202H27.4583V22.7253C27.4583 22.0605 27.2834 21.5442 26.9335 21.1762C26.5837 20.8082 26.1133 20.6243 25.5222 20.6243C24.9312 20.6243 24.4607 20.8082 24.1109 21.1762C23.7611 21.5442 23.5862 22.0605 23.5862 22.7253V28.1202H20.4921V18.185H23.5862V19.5025C23.8998 19.0633 24.322 18.7191 24.8527 18.4698C25.3835 18.2087 25.9806 18.0781 26.644 18.0781Z",
    fill: "url(#paint3_linear_4_88842)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_88842",
    x1: 46.5167,
    y1: -43.181,
    x2: -4.2296,
    y2: -42.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385159,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_88842",
    x1: 17.6783,
    y1: 8.03604,
    x2: 14.1377,
    y2: 8.04211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385159,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_88842",
    x1: 17.6783,
    y1: 10.044,
    x2: 14.1378,
    y2: 10.0642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385159,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_88842",
    x1: 31.2037,
    y1: 8.03604,
    x2: 19.4022,
    y2: 8.10347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E1F9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385159,
    stopColor: "#564CEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_88842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0842,
    height: 19.08,
    fill: "white",
    transform: "translate(12.457 11)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.5b26b61acc03a3a602e68148ecd8dcb2.svg";
export { ForwardRef as ReactComponent };